module.exports = __webpack_public_path__ + "static/home-02-4835703c79792544cb6f991e5d11a109.png";